
import React from 'react';

const AboutHero: React.FC = () => {
  return (
    <section 
      className="relative py-32 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Modern%20biotechnology%20company%20headquarters%20building%20with%20glass%20facade%2C%20professional%20corporate%20environment%2C%20scientists%20and%20researchers%20working%20together%2C%20innovative%20life%20sciences%20company%20atmosphere%20with%20clean%20architectural%20design&width=1920&height=800&seq=about-hero&orientation=landscape')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 text-center text-white">
        <h1 className="text-5xl font-bold mb-6">
          关于<strong>我们</strong>
        </h1>
        <p className="text-xl mb-8 max-w-3xl mx-auto leading-relaxed">
          专注<strong>生物信息学</strong>技术创新，致力于推动生命科学研究和精准医疗发展
        </p>
        <div className="flex flex-wrap justify-center gap-6 mt-12">
          <div className="bg-white/20 backdrop-blur-sm rounded-lg px-8 py-4">
            <span className="text-3xl font-bold block">2021</span>
            <span className="text-sm">成立年份</span>
          </div>
          <div className="bg-white/20 backdrop-blur-sm rounded-lg px-8 py-4">
            <span className="text-3xl font-bold block">100+</span>
            <span className="text-sm">成功项目</span>
          </div>
          <div className="bg-white/20 backdrop-blur-sm rounded-lg px-8 py-4">
            <span className="text-3xl font-bold block">20+</span>
            <span className="text-sm">合作机构</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;